import { useRecoilValue, useSetRecoilState } from 'recoil';
import type { GetWorklistItemQuery } from 'generated/graphql';
import {
  ADDENDUM_STATUSES,
  isReporterLockedState,
  ReportStatus,
  reportStatusState,
} from '../../state';
import { useCurrentCaseClaimedStatus } from 'hooks/useCurrentCaseClaimedStatus';
import { useEffect } from 'react';
import { useCurrentCaseContext } from 'common/CurrentCase/CurrentCaseProvider';

export type UseReportLockedStateReturn = {
  locked: boolean;
  isClaimedByMe: boolean;
  loading: boolean;
  // @ts-expect-error [EN-10263] - TS2339 - Property 'claimedBy' does not exist on type '{ readonly __typename?: "WorklistItem" | undefined; readonly smid: string; readonly mrn?: string | null | undefined; readonly status: WorklistItemStatus; ... 23 more ...; readonly customStatus?: { ...; } | ... 1 more ... | undefined; } | null | undefined'.
  claimedBy: GetWorklistItemQuery['worklistItem']['claimedBy'];
  // @ts-expect-error [EN-10263] - TS2339 - Property 'report' does not exist on type '{ readonly __typename?: "WorklistItem" | undefined; readonly smid: string; readonly mrn?: string | null | undefined; readonly status: WorklistItemStatus; ... 23 more ...; readonly customStatus?: { ...; } | ... 1 more ... | undefined; } | null | undefined'.
  submittedBy: GetWorklistItemQuery['worklistItem']['report']['owner'];
  isAddendumStatus: boolean;
  isSubmittedStatus: boolean;
};

export const useReportLockedState = (): UseReportLockedStateReturn => {
  const { currentCase: worklistItem, loadingCase } = useCurrentCaseContext();

  const { isClaimedByMe, isClaimedBySomeoneElse, isClaimed, isArchived } =
    useCurrentCaseClaimedStatus();

  const status = useRecoilValue(reportStatusState);
  const setIsReporterLocked = useSetRecoilState(isReporterLockedState);
  const isAddendumStatus = ADDENDUM_STATUSES.includes(status as (typeof ADDENDUM_STATUSES)[number]);

  const isSubmittedStatus =
    status === ReportStatus.ProvisionalSubmit || status === ReportStatus.Submitted;

  const unclaimed = !isClaimed && !isArchived;

  const locked =
    loadingCase ||
    worklistItem == null ||
    isClaimedBySomeoneElse ||
    unclaimed ||
    ReportStatus.Submitted === status;

  useEffect(() => {
    setIsReporterLocked(locked);
  }, [locked, setIsReporterLocked]);

  return {
    locked,
    isClaimedByMe,
    loading: loadingCase,
    claimedBy: worklistItem?.claimedBy,
    submittedBy: worklistItem?.report?.owner,
    isAddendumStatus,
    isSubmittedStatus,
  };
};
